import React from 'react';

import constants from '../../utils/constants';

const HowKabbageWorks = () => {
  const {
    sites: { us },
  } = constants;

  return (
    <section className="med-hi how-kabbage-works">
      <div className="arrow-down" />
      <div className="container">
        <div className="container">
          <h2 className="h1-style">
            How a Kabbage Funding line of credit works:
          </h2>
          <hr />
          <div className="how-row">
            <div className="column number">1</div>
            <div className="column name">Apply anywhere in minutes</div>
            <div className="column image">
              <div className="one" />
            </div>
            <div className="column text">
              Enter basic business information and link your revenue data online
              or through our mobile app.
            </div>
          </div>
          <hr />
          <div className="how-row">
            <div className="column number">2</div>
            <div className="column name">
              Get a decision quickly<sup>2,4</sup>
            </div>
            <div className="column image">
              <div className="two" />
            </div>
            <div className="column text">
              We&#39;ll review your business performance to let you know how
              much working capital you can access.
            </div>
          </div>
          <hr />
          <div className="how-row">
            <div className="column number">3</div>
            <div className="column name">Start using your funds today</div>
            <div className="column image">
              <div className="three" />
            </div>
            <div className="column text">
              Take the amount you need now and come back whenever you need more
              capital to grow your business.
            </div>
          </div>
          <hr />
        </div>
        <div className="find-out-buttons">
          <h3>find out more</h3>
          <a
            className="pill-button green medium"
            href={`https://${us}/how-it-works/qualifying/`}
          >
            Qualifying
          </a>
          <a
            className="pill-button green medium"
            href={`https://${us}/what-it-costs/loan-rates-and-terms/`}
          >
            Rates &#38; Terms
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowKabbageWorks;
